module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.modalOpen) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_c('div', [_c('md-steppers', {
    attrs: {
      "md-active-step": _vm.active,
      "md-linear": ""
    },
    on: {
      "update:mdActiveStep": function($event) {
        _vm.active = $event
      }
    }
  }, [_c('md-step', {
    attrs: {
      "id": "first",
      "md-label": "Select Image",
      "md-done": _vm.first
    },
    on: {
      "update:mdDone": function($event) {
        _vm.first = $event
      }
    }
  }, [_c('md-content', {
    staticClass: "content-area md-scrollbar"
  }, [_c('image-select', {
    on: {
      "save-image-to-catalogue": _vm.saveImageToCatalogue,
      "process-file-array": _vm.processFileArray,
      "process-file-url": _vm.processFileUrl
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex bottom-buttons"
  }, [_c('div'), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.modalOpen = false
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("NEXT")])])], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "id": "second",
      "md-label": "Edit Image",
      "md-done": _vm.second
    },
    on: {
      "update:mdDone": function($event) {
        _vm.second = $event
      }
    }
  }, [_c('md-content', {
    staticClass: "content-area md-scrollbar"
  }, [_c('image-edit', {
    ref: "imageEdit",
    on: {
      "save-data": _vm.processFileArray,
      "save-image-to-catalogue": _vm.saveImageToCatalogue
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex bottom-buttons"
  }, [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.setDone('second', 'first')
      }
    }
  }, [_vm._v("PREVIOUS")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.modalOpen = false
      }
    }
  }, [_vm._v("CANCEL")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.$refs.imageEdit.saveImageData()
      }
    }
  }, [_vm._v("NEXT")])])], 1), _vm._v(" "), _c('md-step', {
    attrs: {
      "id": "third",
      "md-label": "Crop Image",
      "md-done": _vm.third
    },
    on: {
      "update:mdDone": function($event) {
        _vm.third = $event
      }
    }
  }, [_c('md-content', {
    staticClass: "content-area md-scrollbar"
  }, [_c('image-crop', {
    ref: "imageCrop",
    attrs: {
      "aspectRatio": _vm.aspectRatio
    },
    on: {
      "crop-data": _vm.gotCropData
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex bottom-buttons"
  }, [(_vm.showSpinner) ? _c('md-progress-spinner', {
    attrs: {
      "md-mode": "indeterminate"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.setDone('third', 'second')
      }
    }
  }, [_vm._v("PREVIOUS")]) : _vm._e(), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.modalOpen = false
      }
    }
  }, [_vm._v("CANCEL")]) : _vm._e(), _vm._v(" "), (!_vm.showSpinner) ? _c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": function($event) {
        _vm.showSpinner = true;
        _vm.$refs.imageCrop.getCropData();
      }
    }
  }, [_vm._v("DONE")]) : _vm._e(), _vm._v(" "), _c('div')], 1)], 1)], 1)], 1)])], 2)])])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14f5fd9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/imageWorkflow.vue
// module id = 628
// module chunks = 1